import React from 'react';
import { Bot } from 'lucide-react';

export const AgentTypingIndicator: React.FC = () => {
  return (
    <div className="flex gap-3 justify-start mb-4">
      <div className="flex-shrink-0">
        <div className="w-8 h-8 rounded-full bg-indigo-600 flex items-center justify-center">
          <Bot className="w-5 h-5 text-white" />
        </div>
      </div>

      <div className="bg-gray-100 rounded-lg px-4 py-3 flex items-center gap-2">
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
        <span className="text-sm text-gray-600">L'assistente sta scrivendo...</span>
      </div>
    </div>
  );
};
